<template>
  <div>
    <div class="pb-4">
      <v-layout row align-start justify-start v-if="willOpportunityOpen && isEligible">
        <div class="pt-1">
          <v-avatar size="30" :color="themes.candidate.light.success">
            <v-icon dark small>mdi-calendar</v-icon>
          </v-avatar>
        </div>
        <div class="px-2">
          Congrats! You are eligible to apply for this opportunity.
          <br />Applications open in
          <span class="font-weight-bold">{{ timeToClosingDate }}</span>
          ({{ new Date(this.opportunity.opensAt) | date('d MMM yyy') }})
        </div>
      </v-layout>

      <v-layout row align-start justify-start v-else-if="isOpportunityClosed">
        <div>
          <v-avatar size="30" :color="themes.candidate.light.muted">
            <v-icon dark small>mdi-calendar</v-icon>
          </v-avatar>
        </div>
        <div class="pt-1 px-2">
          Applications for this opportunity are closed.
        </div>
      </v-layout>

      <v-layout row align-start justify-start v-else-if="!isEligible && !isReferred">
        <div class="pt-1">
          <v-avatar size="30" :color="themes.candidate.light.error">
            <v-icon dark small>mdi-thumb-down</v-icon>
          </v-avatar>
        </div>
        <div class="px-2">
          <p>
            Based on the information you provided it does not look like you qualify for this
            opportunity. Please see the minimum requirement information below.
          </p>
        </div>
      </v-layout>

      <div v-else-if="(isEligible || isReferred) && isOpportunityOpen" class="px-2">
        <v-form v-model="valid" v-if="opportunity.locations" ref="form">
          <v-select
            ref="select"
            v-model="locations"
            label="Opportunity Locations"
            :color="themes.candidate.light.input"
            :items="opportunity.locations"
            :rules="rules"
            hint="Choose your preferred locations"
            item-text="address"
            item-value="id"
            persistent-hint
            return-object
            multiple
            :menu-props="{ offsetY: true }"
          />
        </v-form>
        <v-btn
          color="success"
          :loading="applying"
          :disabled="!valid || applying"
          @click.stop="apply"
          class="px-4"
          block
        >
          Submit Application
        </v-btn>
      </div>
    </div>

    <OpportunityRequirementsGuide
      v-if="eligibility && eligibility.requirementGroups"
      :requirementGroups="eligibility.requirementGroups"
      :opportunity="opportunity"
      :askSupport="!isEligible"
    />
  </div>
</template>

<script>
// Components
import OpportunityRequirementsGuide from '@/components/guest/opportunities/OpportunityRequirementsGuide'

// Helpers
import _ from 'lodash'

// Mixins
import { OpportunityDates } from '@/mixins/OpportunityDates.js'

export default {
  mixins: [OpportunityDates],

  components: { OpportunityRequirementsGuide },

  created() {
    this.$store.dispatch('candidate/eligibilities/checkEligibility', this.opportunity).finally(() => {
      this.loading = false
      if (_.get(this, '$refs.select')) this.$refs.select.focus()
    })
  },

  props: { opportunity: { type: Object, required: true } },

  data() {
    return {
      loading: true,
      applying: false,
      locations: [],
      valid: true,
      rules: [v => v.length > 0 || 'Must select location(s)'],
    }
  },

  computed: {
    eligibility() {
      return this.$store.getters['candidate/eligibilities/forOpportunity'](this.opportunity.id)
    },

    isEligible() {
      return this.eligibility && this.eligibility.eligible
    },

    isReferred() {
      return this.eligibility && !!this.eligibility.referredAt
    },
  },

  methods: {
    apply() {
      if (this.$refs['form'].validate()) {
        this.applying = true

        this.$store
          .dispatch('candidate/opportunities/apply', {
            opportunity: this.opportunity,
            locations: this.locations,
          })
          .then(
            ({ data }) => {
              // Success
              this.$store.dispatch('snackbarSuccess', 'Application Submitted')
              this.$emit('done', data)
              this.applying = false
            },
            // Failure
            () => {
              this.$store.dispatch('snackbarError', 'Error Occured')
              this.applying = false
            }
          )
      }
    },
  },
}
</script>
